import { render } from "./AddServicePage.vue?vue&type=template&id=c40ff7b2&ts=true"
import script from "./AddServicePage.vue?vue&type=script&lang=ts"
export * from "./AddServicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__